export const labelClasses = 'block text-sm font-medium text-neutral-700';

export const inputWrapperClasses = 'mt-1 flex rounded-control';

export const inputClasses =
  'appearance-none block w-full px-3 py-2 rounded-control placeholder-neutral-400 border border-standard bg-surface text-neutral-900 text-sm shadow-input focus:outline-none focus:border-blue focus:shadow-input-focus transition-[border-color,box-shadow] duration-150 ease-out';
